/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import {
  Box,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import YouTube from 'react-youtube';
import { useMediaQuery } from 'react-responsive';
// import ReactPlayer from 'react-player';
/* Internal Imports */
/* Components */
import MidContainer from '@Layout/MidContainer';
import LiteYouTubeEmbed from '@components/Embeds/YoutubeEmbed';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import { getEmbedUrl } from '@components/Utility/utils';
import config from '@config';

/* Services */
/* Styles */
import styles from '@lb/components/Embeds/RitualEmbed.module.css';
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

/**
 * @param {object} sectionContent - Data for Section
 * @param margin
 * @param width
 * @param pxBase
 * @returns {ReactElement} MediaEmbed component
 */

const RitualEmbed = ({ sectionContent, margin, width, pageData }) => {
  // const [vidVis, setVidVis] = useState(false);
  const [opts, setOpts] = useState({});
  const [imageDimensions, setImageDimensions] = useState({
    width: 0,
    height: 0,
  });
  const { isOpen, onOpen, onClose } = useDisclosure();
  const isMobileStyle = useMediaQuery({ query: '(max-width: 768px)' });

  useEffect(() => {
    setOpts({
      height: document.getElementById('msr-vid')?.clientHeight,
      // height: '315',
      width: '100%',
      playerVars: {
        autoplay: 1,
      },
    });
  }, [global?.window]);

  // Load image to get natural dimensions
  useEffect(() => {
    const isMobile = window.innerWidth <= 768;
    const imageUrl = isMobile
      ? pageData?.videoMobileThumbnail?.url ||
        sectionContent?.thumbnailMobileImage?.url ||
        sectionContent?.mobileImage?.url ||
        sectionContent?.thumbnailUrl
      : pageData?.videoDesktopThumbnail?.url ||
        sectionContent?.thumbnailDesktopImage?.url ||
        sectionContent?.image?.url ||
        sectionContent?.thumbnailUrl;

    if (imageUrl) {
      const img = new Image();
      img.onload = () => {
        const containerWidth = isMobile ? window.innerWidth - 30 : 1300; // Account for padding
        const aspectRatio = img.naturalHeight / img.naturalWidth;
        const calculatedHeight = containerWidth * aspectRatio;
        setImageDimensions({
          width: containerWidth,
          height: calculatedHeight,
        });
      };
      img.src = imageUrl;
    }
  }, [sectionContent, pageData]);

  const onReady = event => {
    event.target.playVideo();
  };
  let url =
    sectionContent?.embedUrl ||
    sectionContent?.url ||
    sectionContent?.video?.url;
  let splitUrl = url?.split('&');
  url = splitUrl[0];
  if (
    sectionContent?.image?.url ||
    pageData?.videoDesktopThumbnail?.url ||
    sectionContent?.thumbnailDesktopImage?.url ||
    sectionContent?.thumbnailUrl
  ) {
    return (
      <>
        {/* {sectionContent.style === 'lb-inline-video' ? ( */}
        <Box
          width="100%"
          display="flex"
          justifyContent="center"
          alignItems="center"
        >
          <Box
            width={{ base: '100%', md: '1330px' }}
            maxW={{ base: '100%', md: '1330px' }}
            margin="0 auto"
            height="auto"
            px={{ base: '15px', md: '0' }}
            pb={sectionContent?.thumbnailUrl ? '50px' : '0px'}
          >
            <Box
              pos="relative"
              width="100%"
              height={{
                base: imageDimensions.height
                  ? `${imageDimensions.height}px`
                  : '250px',
                md: '500px',
              }}
              backgroundImage={{
                base:
                  pageData?.videoMobileThumbnail?.url ||
                  sectionContent?.thumbnailMobileImage?.url ||
                  sectionContent?.mobileImage?.url ||
                  sectionContent?.thumbnailUrl,
                md:
                  pageData?.videoDesktopThumbnail?.url ||
                  sectionContent?.thumbnailDesktopImage?.url ||
                  sectionContent?.image?.url ||
                  sectionContent?.thumbnailUrl,
              }}
              backgroundSize="contain"
              backgroundPosition="center"
              backgroundRepeat="no-repeat"
            >
              {/* Centered Video Play Icon */}
              <Box
                pos="absolute"
                top="50%"
                left="50%"
                transform="translate(-50%, -50%)"
                zIndex="2"
              >
                <Box
                  w={{ base: '60px', md: '104px' }}
                  h={{ base: '60px', md: '104px' }}
                  onClick={onOpen}
                  cursor="pointer"
                  transition="transform 0.2s ease"
                  _hover={{ transform: 'scale(1.1)' }}
                >
                  <LazyLoadImageComponent
                    objectFit="contain"
                    w={{ base: '60px', md: '104px' }}
                    h={{ base: '60px', md: '104px' }}
                    src={`${config.imgPath}/d/46272/1681964046-icon.svg`}
                  />
                </Box>
              </Box>
              <Box
                pos={'absolute'}
                top="76%"
                left="50%"
                transform="translate(-50%, -50%)"
                lineHeight="100%"
                textAlign="center"
                zIndex="1"
                fontFamily="FedraSerifDisplay"
                fontSize={{ base: '20px', md: '40px' }}
                color="#F3F0E6"
                /* Triveni change */
                // pos="absolute"
                // bottom="10px"
                // lineHeight="100%"
                // left={{ base: '5%', md: '10%' }}
                // fontFamily="FedraSerifDisplay"
                // fontSize={{ base: '46px', md: '80px' }}
                // color="#F3F0E6"
              >
                {sectionContent.title}
              </Box>
            </Box>
            <Modal
              isOpen={isOpen}
              onClose={onClose}
              size="6xl"
              isCentered
              closeOnOverlayClick={false}
            >
              <ModalOverlay bg="rgba(0, 0, 0, 0.7)" />
              <ModalContent
                p={0}
                m="0"
                bg={{ base: '#000000' }}
                // transform={{ base: 'rotate(270deg)', md: 'none' }}
                maxW={{ base: 'auto', md: '992px' }}
                maxH={{ base: '357px', md: '587px' }}
              >
                <ModalCloseButton
                  _hover={{ bg: '#fff', color: '#000' }}
                  _active={{ bg: '#fff', color: '#000' }}
                  _focus={{ bg: '#fff', color: '#000' }}
                  zIndex="20"
                  top="-5px"
                  bg="#fff"
                  color="#000"
                  right="-5px"
                  rounded="full"
                  className={styles.closeButton}
                />
                <ModalBody p={0} m="0" w="100%" position="relative">
                  <Box
                    pos={{ base: 'static', md: 'static' }}
                    left="50%"
                    right="50%"
                    // transform={{ md: 'none', base: 'translate(-50%, -50%)' }}
                    display={{ base: 'flex', md: 'block' }}
                    justifyContent={{ base: 'center' }}
                    alignItems={{ base: 'center' }}
                  >
                    <Box
                      bg="#FFFFFF"
                      onClick={onClose}
                      w="32px"
                      h="32px"
                      rounded="full"
                      _hover={{ bg: '#ffffff' }}
                      display={{ base: 'grid', md: 'none' }}
                      placeItems="center"
                      pos="absolute"
                      top="-145px"
                      left="-185px"
                      fontFamily="FedraSansStd-Book"
                      zIndex="10"
                      cursor="pointer"
                      color="black"
                    >
                      x
                    </Box>
                    <YouTube
                      videoId={getEmbedUrl(url)}
                      onReady={onReady}
                      opts={opts}
                      loading="lazy"
                      className={styles.RitualEmbed}
                    />{' '}
                  </Box>
                  {/* </Box> */}
                </ModalBody>
              </ModalContent>
            </Modal>
          </Box>
        </Box>
      </>
    );
  }

  let pb = '56.25%';
  if (sectionContent?.source === 'soundcloud') {
    pb = 0;
  } else {
    pb = '22%';
  }

  return sectionContent?.embedUrl || sectionContent?.url ? (
    <MidContainer w={width || '755px'}>
      <Box
        className="msr-vid"
        position="relative"
        display="block"
        width={width}
        pb={pb}
        height="auto"
        m={
          sectionContent?.source === 'soundcloud'
            ? '0px'
            : margin || '30px auto'
        }
        px="{{ base: pxBase || '15px', md: 0 }}"
        // {...props}
      >
        {sectionContent?.source === 'youtube' ||
          (sectionContent?.embedUrl?.indexOf('youtube.com') > -1 && (
            <LiteYouTubeEmbed
              id={getEmbedUrl(sectionContent?.embedUrl)}
              embedUrl={getEmbedUrl(sectionContent?.embedUrl)}
              cookie
            />
          ))}

        {/* {sectionContent?.source === 'facebook' && (
          <FacebookPlayer
            className="fb-player"
            // videoId="2749633985172495"
            videoId={sectionContent?.embedUrl}
            appId="1503437569957732"
            // width={500}
            // height="auto"
            allowfullscreen={false}
            autoplay={true}
          />
        )} */}

        {sectionContent?.source === 'soundcloud' && (
          // Special styling for SoundCloud Triveni Page
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            minHeight="500px"
            mx={{ base: 4, md: 0 }}
          >
            <Box
              as="iframe"
              title="SoundCloud Player"
              width="100%"
              height="450"
              maxW="700px"
              w="100%"
              // mx="auto"

              boxShadow="0px 5px 10px 0px rgba(0,0,0,0.10), 0px 18px 18px 0px rgba(0,0,0,0.09)"
              border="none"
              background="none"
              borderRadius="0"
              p="0"
              style={{
                display: 'block',
                background: 'none',
                boxShadow:
                  '0px 5px 10px 0px rgba(0,0,0,0.10), 0px 18px 18px 0px rgba(0,0,0,0.09)',
                border: 'none',
                borderRadius: 0,
                padding: 0,
              }}
              src={
                isMobileStyle
                  ? getEmbedUrl(sectionContent?.embedUrl) +
                    '&show_artwork=false'
                  : getEmbedUrl(sectionContent?.embedUrl)
              }
            />
          </Box>
        )}

        {sectionContent?.source !== 'facebook' &&
          sectionContent?.source !== 'youtube' &&
          sectionContent?.source !== 'soundcloud' && (
            <Box
              as="iframe"
              width="100%"
              allowFullScreen
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
              }}
              src={getEmbedUrl(sectionContent?.embedUrl)}
            />
          )}
      </Box>
      <style>
        {`.fb-player {
          width:100%;
          height: auto;
          max-height: 600px;
        }`}
      </style>
    </MidContainer>
  ) : null;
};

export default RitualEmbed;
